import React from 'react';
import "./StaticPage.css";

const StaticPage: React.FC = () => {
  return (
    <>
        <div className="wrapper">
            <div className="wrapper_Body">
                <div className="container">
                    <h1 className="headerText"> Trade Payables Services</h1>
                    <p><a className="fontRed">PLEASE NOTE</a></p>
                    <div className="fontBlack">
                        The MUFG Remittance Portal is no longer <br/>accessible from this URL.
                        <br/><br/><br/>
                        The new URL is: <a className="supplier_link" href="https://supplier.tradepayables.com"><br/>https://supplier.tradepayables.com</a>.
                        <br/><br/><br/>
                        Please bookmark this new URL.
                    </div>
                </div>
            </div>
        </div>
    </>
  );
};

export default StaticPage;
